module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rooms"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(!_vm.hasLoaded) ? _c('loader') : _c('div', {
    staticClass: "col-lg-6 col-lg-offset-2 col-md-8 col-md-offset-1 col-sm-12"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_vm._l((_vm.sortedMeta), function(property) {
    return _c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-sm-4 control-label"
    }, [_vm._v(_vm._s(property.label))]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-8"
    }, [(property.type === null || property.type === 'text') ? _c('input', {
      staticClass: "form-control",
      attrs: {
        "data-field": property.field,
        "type": "text"
      },
      domProps: {
        "value": property.value
      },
      on: {
        "keyup": _vm.addUpdate
      }
    }) : (property.type === 'textarea') ? _c('textarea', {
      staticClass: "form-control",
      attrs: {
        "data-field": property.field
      },
      domProps: {
        "value": property.value
      },
      on: {
        "keyup": _vm.addUpdate
      }
    }) : _vm._e()])])
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-offset-4 col-sm-8"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.update
    }
  }, [_vm._v("Update information")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.signOut
    }
  }, [_vm._v("Click here to sign out")])])], 2)])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v("\n            Settings\n        ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38e9f86a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/settings/Settings.vue
// module id = 390
// module chunks = 1